@use "foundation/responsive";

.spinner {
  height: 2em;

  span {
    top: 3.75em;

    @include responsive.phone {
      top: 3em;
    }
  }
}
